import { render, staticRenderFns } from "./RemarkComponent.vue?vue&type=template&id=af907698&scoped=true&"
import script from "./RemarkComponent.vue?vue&type=script&lang=js&"
export * from "./RemarkComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af907698",
  null
  
)

export default component.exports